export default __webpack_public_path__ + "static/media/w-pattern-bg.a026f81e.svg";